import React from 'react';
import { Button, Table, Modal, Input, Grid, Form, TextArea, Dropdown, Image } from 'semantic-ui-react';
import $ from "jquery";

import Loading from '../../loading';
import Adds from '../../media/add.png';
import Server from '../../../functions/server';


class Images extends React.Component {

  state = {
    status: 1, images: [{id: 0, image: Adds}]
  }

  getImages() {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Allow To Add Image');
      return;
    }
    let context = this;
    context.setState({ load: true, message: 'Getting Model' })
    $.ajax({
      type: 'POST', data: { id: context.props.id },
      url: Server() + 'machinemodel/getimages.php',
      success: function(data) {
        let images = context.state.images;
        try {
          data = JSON.parse(data);
          data.map((c) => { images.push(c); })
          context.setState({ images, load: false, open: true })
        } catch (e) {
          alert('Error!!!')
          context.setState({  load: false })
        }
      },
      error: function (e) {
        alert(e)
        context.setState({ load: false });
      }
    });
  }


  updateLocalfile(image) {
    let context = this;
    var formData = new FormData();
    formData.append('image', image);
    formData.append('id', this.props.id);
    context.setState({ load: true, message: 'Update Image', images: [{id: 0, image: Adds}] })
    $.ajax({
      type: 'POST', processData: false,
      contentType: false, data: formData,
      url: Server() + 'machinemodel/updatemultipleimage.php',
      success: function(data) {
        if (data == 1) {
          alert('Image Added Successfully');
          context.getImages();
          context.setState({ load: false });
        }
        else {
          context.setState({ load: false });
        }
      },
      error: function(error) {
        console.log(error);
      }
    });
  }

  deleteImage(id) {
    let context = this;
    let data = { id };
    $.ajax({
      type: 'POST', data: { id },
      url: Server() + 'machinemodel/deleteimage.php',
      success: function(data) {
        let images = context.state.images;
        let image = [];
        if (data == 1) {
          alert('Image Delete Successfully');
          images.map((c) => { if (c.id != id) { image.push(c); } });
          context.setState({ load: false, images: image });
        }
        else {
          context.setState({ load: false });
        }
      },
      error: function(error) {
        console.log(error);
      }
    });
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <center style={{color: 'blue', cursor: 'pointer', fortWeight: 'bold'}} onClick={this.getImages.bind(this)}>Images</center>
        <Modal open={this.state.open} onClose={ () => { this.setState({ open: false, images: [{id: 0, image: Adds}] }) }}>
          <Modal.Content>
            <Grid>
              { this.state.images.map((c) => {
                  if (c.id == 0) {
                    return (
                      <Grid.Column mobile={16} tablet={16} computer={3}>
                        <input id={'1'} type="file" onChange={(e) => { this.updateLocalfile(e.target.files[0]); }} style={{display: 'none'}}/>
                        <label htmlFor={'1'}>
                          <Image src={c.image} size='small' style={{width: '100%', height: '130px', cursor: 'pointer'}} id='image' />
                        </label>
                      </Grid.Column>
                    )
                  }
                  else {
                    return (
                      <Grid.Column mobile={16} tablet={16} computer={3}>
                        <Image src={c.image} size='small' style={{width: '100%', height: '130px', cursor: 'pointer'}} id='image' />
                        <center style={{color: 'red', cursor: 'pointer'}} onClick={this.deleteImage.bind(this, c.id)}>Delete</center>
                      </Grid.Column>
                    )
                  }
                })
              }
            </Grid>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={ () => { this.setState({ open: false, images: [{id: 0, image: Adds}] }) }} negative>
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default Images;
